import React from "react";
import styled from "styled-components";
import Loading from "sweet-web/components/universal/Loading";
import { colors } from "sweet-web/lib/styles";

type ButtonProps = {
  link?: boolean;
  color?: string;
  noHover?: boolean;
  small?: boolean;
};
const StyledButton = styled.button<ButtonProps>`
  width: auto;
  padding: 7px 10px;
  white-space: nowrap;
  background-color: ${colors.white};
  color: ${props => (props.color ? props.color : colors.gray)};
  font-size: ${props => (props.small ? 12 : 14)}px;
  font-weight: 500;
  transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  outline: none;
  border: none;
  ${props =>
    props.noHover
      ? ``
      : `&:hover {
    cursor: ${props => (props.link ? "pointer" : "cursor")};
    transform: scale(1.03);
    color: ${colors.primary};
  }`}
`;

type Props = {
  disabled?: boolean;
  loading?: boolean;
  title: string;
  onClick?: () => void;
  style?: object;
  link?: boolean;
  color?: string;
  noHover?: boolean;
  small?: boolean;
};
const TextButton: React.FC<Props> = props => {
  return (
    <StyledButton
      style={props.style}
      link={props.link}
      type={"button"}
      small={props.small}
      noHover={props.noHover}
      color={props.color}
      disabled={props.disabled || props.loading}
      onClick={() => {
        if (props.onClick) props.onClick();
      }}
    >
      {props.loading ? <Loading size={18} /> : props.title}
    </StyledButton>
  );
};
TextButton.defaultProps = {
  style: {},
  link: false
};

export default TextButton;
